import React, { Component } from "react";
import firebase from "../../../firebase/index";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    option1: "How can I assist you with the smart lock?",
    option2:
      "How can I assist you with the Intelligent Access Management System?",
    option3: "How can I assist you with the mobile app?",
    invalid: "Invalid message received",
  },
  ja: {
    option1: "スマートロックについてどのようにお手伝いできますか？",
    option2:
      "インテリジェントアクセス管理システム（IAM）についてどのようにお手伝いできますか？",
    option3: "モバイルアプリについてどのようにお手伝いできますか？",
    invalid: "無効なメッセージを受信しました",
  },
  es: {
    option1: "¿Cómo puedo ayudarte con la candado inteligente?",
    option2:
      "¿Cómo puedo ayudarte con el Sistema de Gestión Inteligente de Acceso (IAM)?",
    option3: "¿Cómo puedo ayudarte con la aplicación móvil?",
    invalid: "Mensaje recibido inválido",
  },
});

class StoreData extends Component {
  state = {
    user: null,
  };

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
        });
    }

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({ user });
        this.fetchUserData(user.uid);
      } else {
        this.setState({ user: null });
        const userDataStep = this.props.steps["not_login_2"];
        const { name, company, email } = userDataStep.value;
        const problems = this.props.steps["problem_questions"];
        const message = problems.message;
        const userdata = {
          name: name,
          Companyname: company,
          email: email,
          problems: message,
        };
        fire
          .database()
          .ref("bot-datacollection")
          .push({ userdata });

        if (
          message == "Smart Lock" ||
          message == "スマートロック" ||
          message == "Candado Inteligente"
        ) {
          this.props.triggerNextStep({ trigger: "lock-choices" });
        } else if (
          message == "Intelligent Access Management System" ||
          message == "インテリジェントアクセス管理システム" ||
          message == "Sistema de Gestión de Acceso Inteligente"
        ) {
          this.props.triggerNextStep({ trigger: "web-choices" });
        } else if (
          message == "Mobile App" ||
          message == "モバイルアプリケーション" ||
          message == "Aplicación Móvil"
        ) {
          this.props.triggerNextStep({ trigger: "mobile-choices" });
        }
      }
    });
  }
  fetchUserData = (uid) => {
    firebase
      .database()
      .ref("registeredIndustrialUsersOnPlatform")
      .child(uid)
      .on("value", (snapshot) => {
        const userData = snapshot.val();

        if (userData) {
          const { name, company, email } = userData;
          const problems = this.props.steps["problem_questions"];
          const message =
            problems.message == "Smart Lock" ||
            problems.message == "スマートロック" ||
            problems.message == "Candado Inteligente"
              ? "Smart Lock"
              : problems.message == "Intelligent Access Management System" ||
                problems.message == "インテリジェントアクセス管理システム" ||
                problems.message == "Sistema de Gestión de Acceso Inteligente"
              ? "Intelligent Access Management System"
              : problems.message == "Mobile App" ||
                problems.message == "モバイルアプリケーション" ||
                problems.message == "Aplicación Móvil"
              ? "Mobile App"
              : "Unknown";
          const userdata = {
            name: name,
            Companyname: company,
            email: email,
            problems: message,
          };
          fire
            .database()
            .ref("bot-datacollection")
            .push({ userdata });
          if (
            message == "Smart Lock" ||
            message == "スマートロック" ||
            message == "Candado Inteligente"
          ) {
            this.props.triggerNextStep({ trigger: "lock-choices" });
          } else if (
            message == "Intelligent Access Management System" ||
            message == "インテリジェントアクセス管理システム" ||
            message == "Sistema de Gestión de Acceso Inteligente"
          ) {
            this.props.triggerNextStep({ trigger: "web-choices" });
          } else if (
            message == "Mobile App" ||
            message == "モバイルアプリケーション" ||
            message == "Aplicación Móvil"
          ) {
            this.props.triggerNextStep({ trigger: "mobile-choices" });
          }
        }
      });
  };

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const problems = this.props.steps["problem_questions"];
    const message = problems.message;

    if (
      message == "Smart Lock" ||
      message == "スマートロック" ||
      message == "Candado Inteligente"
    ) {
      return <div>{localizationStrings.option1}</div>;
    } else if (
      message == "Intelligent Access Management System" ||
      message == "インテリジェントアクセス管理システム" ||
      message == "Sistema de Gestión de Acceso Inteligente"
    ) {
      return <div>{localizationStrings.option2}</div>;
    } else if (
      message == "Mobile App" ||
      message == "モバイルアプリケーション" ||
      message == "Aplicación Móvil"
    ) {
      return <div>{localizationStrings.option3}</div>;
    } else {
      return <div>{localizationStrings.invalid}</div>;
    }
  }
}

export default StoreData;
